import React from 'react';

const STATS = [
  { value: '24/5', label: 'Markets monitored', sub: 'Equities, futures, options' },
  { value: '<12ms', label: 'Average broker latency', sub: 'Heartbeat to fill' },
  { value: '100%', label: 'Server-side risk validation', sub: 'Before any order routes' },
  { value: '0', label: 'Credentials visible to staff', sub: 'Tokens encrypted end-to-end' },
];

export default function Stats() {
  return (
    <section className="relative border-t border-white/5 bg-white/[0.01]">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-14 lg:py-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5 rounded-md overflow-hidden">
          {STATS.map((s) => (
            <div key={s.label} className="bg-[#0a0a0b] p-8 lg:p-10">
              <p className="font-display text-3xl sm:text-4xl md:text-5xl font-bold gold-text tabular-nums">{s.value}</p>
              <p className="mt-4 text-sm font-medium text-white">{s.label}</p>
              <p className="mt-1.5 text-xs text-zinc-500">{s.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
